import { Media } from "../../../types/media";
import { AboutNone } from "../AboutNone";
import { MediaTypes } from "../../../constants";
import { AboutRoomSettings } from "../AboutRoomSettings";
import { AboutVignette } from "../AboutVignette";
import { AboutCompact } from "../AboutCompact";
import { AboutCoordinationMedia } from "../AboutCoordinationMedia";
import { AboutHome } from "../AboutHome";
import { AboutRoom } from "../AboutRoom";
import { AboutVitality } from "../AboutVitality";
import { AboutCrossOver } from "../AboutCrossOver";
import { AboutShowcase } from "../AboutShowCase";
import { FixaWindow } from "@coworker/reusable/helpers/devices";

interface AboutSectionProps {
  media: Media;
  onSave: (newMedia: Media) => void;
}

export const AboutSection = ({ media, onSave }: AboutSectionProps) => {
  const enableNewMediaTypes = (window as FixaWindow).enableNewMediaTypes;

  return (
    <>
      {media.mediaType === MediaTypes.NONE && <AboutNone />}
      {media.mediaType === MediaTypes.ROOM_SETTINGS && (
        <AboutRoomSettings
          media={media}
          onSave={(newMedia) => onSave(newMedia)}
        />
      )}
      {media.mediaType === MediaTypes.VIGNETTE && (
        <AboutVignette media={media} onSave={(newMedia) => onSave(newMedia)} />
      )}
      {media.mediaType === MediaTypes.COMPACT && (
        <AboutCompact media={media} onSave={(newMedia) => onSave(newMedia)} />
      )}
      {media.mediaType === MediaTypes.COORDINATION_MEDIA && (
        <AboutCoordinationMedia
          media={media}
          onSave={(newMedia) => onSave(newMedia)}
        />
      )}
      {media.mediaType === MediaTypes.HOME && (
        <AboutHome media={media} onSave={(newMedia) => onSave(newMedia)} />
      )}
      {enableNewMediaTypes && (
        <>
          {media.mediaType === MediaTypes.VITALITY && (
            <AboutVitality
              media={media}
              onSave={(newMedia) => onSave(newMedia)}
            />
          )}
          {media.mediaType === MediaTypes.CROSS_OVER && (
            <AboutCrossOver
              media={media}
              onSave={(newMedia) => onSave(newMedia)}
            />
          )}
          {media.mediaType === MediaTypes.SHOWCASE && (
            <AboutShowcase
              media={media}
              onSave={(newMedia) => onSave(newMedia)}
            />
          )}
        </>
      )}
      {media.mediaType === MediaTypes.ROOM && <AboutRoom media={media} />}
    </>
  );
};
